import FJActionConstant from "../../constant/FJActionConstant";
import FJNetworkStore from "../../store/FJNetworkStore";

export default {
    // 打开视图
    openSubscribeView: (obj) => {
        return {
            type: FJActionConstant.SHOW_SUBSCRIBE_VIEW,
            entry: obj.entry,
            method: obj.method,
            planType: obj.planType,
            additionalSeatCount: obj.additionalSeatCount,
            calculatorSeatCount: obj.calculatorSeatCount
        }
    },
    // 关闭视图
    closeSubscribeView: function () {
        return (dispatch, getState) => {
            dispatch({
                type: FJActionConstant.CLOSE_SUBSCRIBE_VIEW,
            })
            dispatch(this.changeStepAction(1))
        }
    },
    openEditCardInfoPopup: (params = null) => {
        return {
            type: FJActionConstant.OPEN_CARD_INFO_EDIT_POPUP,
            status: true,
						cardParams: params,
        }
    },
    closeEditCardInfoPopup: () => {
        return {
            type: FJActionConstant.CLOSE_CARD_INFO_EDIT_POPUP,
            status: false
        }
    },
    changePayMethodAction: (method) => {
        return {
            type: FJActionConstant.CHANGE_PAY_METHOD,
            method: method
        }
    },
    changeStepAction: (step) => {
        return {
            type: FJActionConstant.CHANGE_CURRENT_STEP,
            step: step
        }
    },
    changeSelectPageAction: (page) => {
        return {
            type: FJActionConstant.CHANGE_SELECT_PAGE,
            selectPage: page
        }
    },
    changeLoadingStatusAction: (status) => {
        return {
            type: FJActionConstant.CHANGE_LOADING_STATUS,
            status: status
        }
    },
    setCurrentPlan: (obj) => {
        return {
            type: FJActionConstant.SET_CURRENT_PLAN,
            obj: obj
        }
    },
    setDataInfo: (obj) => {
        return {
            type: FJActionConstant.SET_DATA_INFO,
            obj: obj
        }
    },
    setDiscountConfAction: (obj) => {
        return {
            type: FJActionConstant.SET_DISCOUNT_CONF,
            obj: obj
        }
    },
    setPaypalSdkAction: (value) => {
        return {
            type: FJActionConstant.SET_PAYPAL_SDK_STATUS,
            value: value
        }
    },
    changeCardInfoAction: function (callback) {
        return (dispatch, getState) => {
            dispatch(this.changeLoadingStatusAction(true))
            // FJGlobalariable.modSubscription.showLoading = true;
            window.FJGlobalariable.modSubscription.network.changeCard().then((response) => {
                switch (response.code) {
                    case 200:
                        let last4 = response.data.last4;
                        window.fj.currentPlan.last4 = last4;
                        this.callback(last4);
                        this.showModal = false;
                        break;
                    case 214:
                        this.showModal = false;
                        this.shouldHideLoading = true;
                        window.FJGlobalariable.modSubscription.noLoginResponseCallback();
                        break;
                    case 204:
                        //因为customer被删除而无法切换信用卡的情况
                        this.showModal = false;
                        window.fj.currentPlan.last4 = '';
                        break;
                    default:
                        this.errorTexts.response = response.msg;
                        this.shouldHideLoading = true;
                        break;
                }
            }).catch((error) => {
                switch (error.type) {
                    case 'stripe':
                        this.errorTexts.response = error.error.message;
                        break;
                    case 'ajax':
                    default:
                        this.errorTexts.response = text_('SUB.CONNECT_NETWORK_FAILED');
                }
                dispatch(this.changeLoadingStatusAction(false))
                // FJGlobalariable.modSubscription.showLoading = false;
            }).finally(() => {
                this.isSubmitting = false;
                if (this.shouldHideLoading) {
                    dispatch(this.changeLoadingStatusAction(false))
                    // FJGlobalariable.modSubscription.showLoading = false;
                }
            });

        }
    },
    setTeamSubscription: (teamSubscription) => {
        return {
            type: FJActionConstant.SET_TEAM_SUBSCRIPTION,
            teamSubscription
        }
    },
    updateSeatCount: (count) => {
        return (dispatch, getState) => {
            const { minSeatCount, maxSeatCount } = getState().mainReducer;
            const seatCount = Math.min(Math.max(count, minSeatCount), maxSeatCount);
            dispatch({
                type: FJActionConstant.UPDATE_SEAT_COUNT,
                count: seatCount,
            });
        }
    },
    updateIsAnnually: (value) => {
        return {
            type: FJActionConstant.UPDATE_IS_ANNUALLY,
            isAnnually: value
        };
    }
}